import { useState, useEffect } from 'react';

/**
 * Hook to validate if an image URL is accessible
 * @param imageUrl - The URL of the image to validate
 * @returns boolean indicating if the image is valid and accessible
 */
export function useImageValidation(imageUrl: string | undefined | null): boolean {
	const [isValid, setIsValid] = useState(false);

	useEffect(() => {
		if (!imageUrl) {
			setIsValid(false);

			return;
		}

		let isCancelled = false;

		const validateImage = () => {
			try {
				// Using Image element to validate if the URL is accessible
				const img = new Image();

				img.onload = () => {
					if (!isCancelled) {
						setIsValid(true);
					}
				};

				img.onerror = () => {
					if (!isCancelled) {
						setIsValid(false);
					}
				};

				img.src = imageUrl;
			} catch (error) {
				if (!isCancelled) {
					setIsValid(false);
				}
			}
		};

		validateImage();

		return () => {
			isCancelled = true;
		};
	}, [imageUrl]);

	return isValid;
}
